import React from 'react';

const PartnersSection = () => {
  // Массив путей к изображениям логотипов
  const logos = [
    '/logos/pik.jpg',
    '/logos/mmk.png',
    '/logos/samolet.jpg',
    '/logos/gazp.jpg',
  ];

  return (
    <section className="py-16 bg-gray-50 border-t">
      <div className="container mx-auto px-4 text-center">
        <h3 className="text-3xl font-bold mb-4">Нам доверяют</h3>
        <p className="text-lg text-gray-600 mb-10">
          Мы поставляем арматуру и металлопрокат крупнейшим строительным компаниям и промышленным предприятиям по всей России.
Клиенты ценят нас за надёжность, быструю логистику и индивидуальный подход к каждому заказу.
Более 50 компаний из разных регионов уже выбрали нас в качестве надёжного поставщика — от частных подрядчиков до крупных корпораций.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 items-center justify-items-center">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="w-36 h-36 rounded-full flex items-center justify-center"
            >
              <img
                src={logo}
                alt={`Logo ${index + 1}`}
                className="w-32 h-32 object-cover rounded-full"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
